var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:({
       content: _vm.state.description,
       html: true
     }),expression:"{\n       content: state.description,\n       html: true\n     }"}],staticClass:"status-box",class:{'selected': _vm.selected, 'cursor-pointer': _vm.clickable },on:{"click":_vm.clickBox}},[_c('div',{staticClass:"status-arrow"}),_c('div',{staticClass:"status-arrow"}),_vm._v(" "+_vm._s(_vm.state.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }